<template>
  <div class="chat-bubble">
    <div class="typing">
      <div class="dot"></div>
      <div class="dot"></div>
      <div class="dot"></div>
    </div>
  </div>
</template>

<script lang="ts">
import { Options, Vue } from 'vue-class-component'

@Options({})
export default class ChatBubble extends Vue {}
</script>

<style scoped lang="scss">
.chat-bubble {
  margin-left: -20px;
  border-radius: 15px;
  padding: 15px 15px;
  display: inline-block;
  position: relative;

  .typing {
    display: flex;
    gap: 4px;
    align-items: center;
    height: 17px;
  }

  .dot {
    width: 6px;
    height: 6px;
    background: rgba(var(--v-theme-on-surface), var(--v-high-emphasis-opacity));
    border-radius: 50%;
    animation: bounce 1.8s linear infinite;
  }

  .dot:nth-child(2) {
    animation-delay: 0.3s;
  }

  .dot:nth-child(3) {
    animation-delay: 0.6s;
  }
}

@keyframes bounce {
  0%, 40%, 100% {
    transform: translateY(0);
  }
  20% {
    transform: translateY(-8px);
  }
}
</style>
